import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type FinalizeFinancialConfirmationModalProps = {
  show: boolean;
  onClose: () => void;
  period: string;
  onConfirm: (sendEmail: boolean) => void;
  isLoading?: boolean;
  showEmailCheckbox?: boolean;
};

export const FinalizeFinancialConfirmationModal = ({
  show,
  onClose,
  period,
  onConfirm,
  isLoading = false,
  showEmailCheckbox = false,
}: FinalizeFinancialConfirmationModalProps) => {
  const [sendEmail, setSendEmail] = useState(false);

  return (
    <Modal.Root open={show} onOpenChange={onClose} modal>
      <Modal.Content onClick={(e) => e.stopPropagation()}>
        <StatusModal type="warning" title="Are you sure?">
          <p className="t-m-0 t-text-body-sm t-text-text-60 t-mb-2">
            You're about to finalise the financials for the period{" "}
            <span className="t-font-bold">{period}</span>. Once approved, no
            further edits can be made to the closing.
          </p>
          {showEmailCheckbox && (
            <Checkbox
              name="send_email"
              label={
                <div className="t-italic t-text-body-sm t-text-text-30">
                  Email the customer their completed financials for this period
                </div>
              }
              checked={sendEmail}
              onChange={(e) => setSendEmail(e.target.checked)}
            />
          )}
        </StatusModal>
        <Modal.Footer className="t-flex t-items-center t-justify-end t-gap-3">
          <Button onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            customType="primary"
            onClick={() => {
              onConfirm(sendEmail);
            }}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Finalize
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
